import request from "./request";

const getXXXW = (datetime) => {
    return request({
        method: "GET",
        url: "/XXXW/time/" + datetime
    })
}

const getXXXWAllowedDate = () => {
    return request({
        method: "GET",
        url: "/XXXW/allowedDate"
    })
}

export { getXXXW, getXXXWAllowedDate };

